<template>
  <Page :title="title">
    <div class="pageView-index">
      <!-- logo -->
      <div class="logo" v-show="shows">
        <img :src="require('@/assets/img/logo.png')" alt="" />
      </div>
      <div
        v-for="(items, index) in list"
        v-bind:key="index"
        class="menu_list_flex"
      >
        <div class="header-wrapper">
          <div class="menu_headerTitl">{{ items.name }}</div>
          <!-- 下拉框 -->
          <div class="role-switch-container" v-if="items.name === '客户管理' && $wxuserUtil.isRoleSwitch()">
            <select v-model="tempSelectedValue" @change="handleSelectChange" class="role-select">
              <option v-if="!tempSelectedValue" disabled value="">请选择角色</option>
              <option v-for="option in selectOptions" :key="option.value" :value="option.value">
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
        <div class="flex">
          <div
            v-for="(item, index) in items.subMenuList"
            class="menu_list"
            v-bind:key="index"
            @click="navigation_(item.id, item)"
          >
            <img
              :src="
                item.icon ? http + item.icon : require('@/assets/img/1.png')
              "
              alt=""
            />
            <div class="menu_list_font">{{ item.name }}</div>
            <div class="statues" v-if="item.num != 0">{{ item.num }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Vant 确认弹窗 -->
    <van-dialog
      v-model="showConfirmDialog"
      title="确认选择"
      :message="confirmMessage"
      show-cancel-button
      @confirm="onConfirm"
      @cancel="onCancel"
    />
  </Page>
</template>



<script>
export default {
  name: "Index-Page",
  data() {
    return {
      title: "首页",
      list: [],
      codes: "",
      sign: "",
      http: this.$http,
      shows: false,
      selectOptions: [], // 下拉框选项
      selectedValue: "", // 下拉框选中的值
      tempSelectedValue: "", // 临时选择的值
      showConfirmDialog: false, // 控制确认弹窗的显示
    };
  },
  computed: {
    selectedOptionText() {
      const option = this.selectOptions.find(opt => opt.value === this.tempSelectedValue);
      return option ? option.text : '';
    },
    confirmMessage() {
      return `您确定要选择 "${this.selectedOptionText}" 吗？`;
    }
  },
  methods: {
    // 获取下拉框数据
    getSelectOptions() {
      // 调用接口获取部门数据
      this.$api.get('api/dealer/listByUserId', {
          userId: this.$wxuserUtil.getUserId()
      }).then(response => {
        if (response.success) {
          this.selectOptions = response.data.map(dept => ({
            text: dept.Name,
            value: dept.id
          }));
          // 手动在数组开头追加一个 “区经” 选项
          this.selectOptions.unshift({ text: "多店负责人", value: -1 });

          // 如果存在已保存的scope并且能匹配到选项，则设置选中值
          const storedScope = this.$wxuserUtil.getScope();
          if (storedScope !== undefined && storedScope !== null && storedScope !== "") {
            const match = this.selectOptions.find(opt => String(opt.value) === String(storedScope));
            if (match) {
              this.selectedValue = String(storedScope);
              this.tempSelectedValue = String(storedScope);
              this.queryWorkBenchCnt();
            }
          }
        } else {
          console.error('获取部门列表失败:', response.msg);
          this.$notify({
            message: '获取部门列表失败',
            duration: 1000,
            background: "#ED1B1B",
          });
        }
      }).catch(error => {
        console.error('获取部门列表异常:', error);
        this.$notify({
          message: '获取部门列表异常',
          duration: 1000,
          background: "#ED1B1B",
        });
      });
    },
    // 下拉框选择事件
    handleSelectChange() {
      if (this.tempSelectedValue) {
        // 弹窗进行二次确认
        this.showConfirmDialog = true;
      }
    },
    // 确认选择
    onConfirm() {
      this.showConfirmDialog = false;
      this.selectedValue = this.tempSelectedValue;
      this.onConfirmAction();
    },
    // 取消选择
    onCancel() {
      this.showConfirmDialog = false;
      this.tempSelectedValue = this.selectedValue;
    },
    // 确认后的回调函数
    onConfirmAction() {
      console.log("操作已确认，执行回调函数，值为: ", this.selectedValue);
      // 存储选择的值到 sessionStorage
      this.$wxuserUtil.setScope(this.selectedValue);

      // 角色切换时需要刷新登录信息和菜单信息
      this.refreshUserInfoAndMenu();
    },
    navigation_(_ID, val) {
      var website = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g.test(val["link"])
      if (!website && this.$wxuserUtil.isRoleSwitch() && !this.selectedValue) {
        this.$title('请先选择角色');
        return;
      }

      this.setState(_ID);
      console.log(_ID);
      this.$parent.IdCode = _ID;
      if (website) {
        //拿到token
        if (_ID == 58) {
          this.chatSale(val);
        } else if (_ID== 61){
          window.location.href =val["link"]+this.$wxuserUtil.getUserId();
        }else {
          window.location.href = val["link"];
        }
      } else {
        /**
         * @param {Number}  _ID      id来判断路由   默认传  路由传递 IdCode 功能按钮权限判断
         **/
        switch (_ID) {
          case 11:
            var params = {
              q: this.$Base64.encode(
                JSON.stringify({
                  notDispatch: "1",
                })
              ),
              name: _ID,
              IdCode: _ID,
              show: 2,
            };
            this.$router.push({ path: "/Client", query: params });
            break;
          case 12:
            this.$router.push({ path: "/Client", query: { IdCode: _ID } });
            break;
          case 14:
            this.$router.push({
              path: "/StoresNumbers",
              query: { IdCode: _ID },
            });
            break;
          case 53:
            this.$router.push({
              path: "/active/apply",
              query: { menuId: _ID, campFlowType: 2 },
            });
            break;
          case 23:
            this.$router.push({
              path: "/active/apply",
              query: { IdCode: _ID },
            });
            break;
          case 24:
            this.$router.push({
              path: "/active/list",
              query: { menuId: _ID, id: "activeList" },
            });
            break;
          case 26:
            this.$router.push({
              path: "/active/reportList",
              query: { IdCode: _ID, id: "reportList" },
            });
            break;
          case 25:
            this.$router.push({
              path: "/active/reportApply",
              query: { IdCode: _ID },
            });
            break;
          // 徕卡学院
          case 19:
            this.$router.push({ path: "/addCurriculum", query: { name: _ID } });
            break;
          case 20:
            this.$router.push({
              path: "/listCurriculum",
              query: { name: _ID },
            });
            break;
          case 21:
            var params = {
              q: this.$Base64.encode(
                JSON.stringify({
                  allCourse: "1",
                })
              ),
              name: _ID,
              IdCode: _ID,
              show: 1,
            };
            this.$router.push({ path: "/Client", query: params });
            break;
          // 销售报表
          case 15:
            this.$router.push({ path: "/clientCare", query: { name: _ID } });
            break;
          case 16:
            this.$wxuserUtil.clearDeptCache();
            this.$router.push({ path: "/resportList", query: { name: _ID } });
            break;
          case 17:
            this.$router.push({
              path: "/report4SalesAnalysis",
              query: { name: _ID },
            });
            break;
          case 60:
            this.$router.push({
              path: "/customer-traffic",
              query: { IdCode: _ID },
            });
            break;
        }
      }
    },

    /**
     *  数字运营平台 处理方式
     */
    chatSale(val) {
      var userId = this.$wxuserUtil.getUserId();
      var that = this;
      var loginTokenData = this.$api.getSync(
        "api/lk/userGetLoginToken?salesId=" + userId,
        {}
      );
      if (loginTokenData.Code == 200) {
        let link =
          val["link"] +
          "?token=" +
          loginTokenData.Data.Token +
          "&strAccount=" +
          userId;
        window.location.href = link;
      } else {
        that.$notify({
          message: loginTokenData.Msg,
          duration: 1000,
          background: "#ED1B1B",
        });
      }
    },

    /**
     *   获取菜单
     *   @param {salesId}
     */
    subMenuList_() {
      var userId = this.$wxuserUtil.getUserId();
      if (!userId) {
        return;
      }

      var key_menu = this.$wxuserUtil.KEY_MENU;
      this.list = this.addMenuList(1, this.$wxuserUtil.getMenu());
      this.shows = true;

      if (!this.list || this.list.length === 0) {
        this.$api.getMenuList({ salesId: userId }).then((response) => {
          if (response.success == true) {
            this.$wxuserUtil.storage.set(key_menu, response.data);
            this.list = this.addMenuList(1, response.data);
            // 菜单加载完成后，加载工作台数量
            if (!this.$wxuserUtil.isRoleSwitch() || this.selectedValue) {
              this.queryWorkBenchCnt();
            }
          } else {
            this.$notify({
              message: `获取菜单失败,${response.msg}`,
              duration: 1000,
              background: "#ED1B1B",
            });
          }
        });
      } else {
        // 当角色切换功能开启且还没有选择角色时，不加载工作台数量
        if (!this.$wxuserUtil.isRoleSwitch() || this.selectedValue) {
          this.queryWorkBenchCnt();
        }
      }
    },
    /**
     *
     * 状态缓存
     *
     **/
    setState(ID) {
      switch (ID) {
        case 12:
          this.$store.commit("setShow", "");
          break;
        case 11:
          this.$store.commit("setShow", 2);
          break;
        case 21:
          this.$store.commit("setShow", 1);
          break;
      }
      switch (ID) {
        case 12:
          localStorage.setItem("show", "");
          break;
        case 11:
          localStorage.setItem("show", 2);
          break;
        case 21:
          localStorage.setItem("show", 1);
          break;
      }
    },
    /**
     *
     * 工作台数量
     *
     **/
    queryWorkBenchCnt() {
      this.$api
        .queryWorkBenchCnt({
          salesId: this.$wxuserUtil.getUserId(),
        })
        .then((response) => {
          if (response.success) {
            let data = [
              {
                id: 11,
                num: response.data.unDispatchCnstCnt || 0,
              },
              {
                id: 15,
                num: response.data.careCustCnt || 0,
              },
              {
                id: 24,
                num: response.data.waitAuditCampCnt || 0,
              },
              {
                id: 26,
                num: response.data.waitAuditCampReportCnt || 0,
              },
            ];
            this.list = this.addMenuList(2, this.list, data);
          }
        });
    },
    /**
     *
     *  追加工作台数量
     *
     */
    addMenuList(ID, data, CD_) {
      if (Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          if (data[i]["subMenuList"] || data[i]["subMenuList"].length > 0) {
            let $D_ = data[i]["subMenuList"];
            for (let o = 0; o < $D_.length; o++) {
              if (ID == 1) {
                $D_[o]["num"] = 0;
              } else {
                for (let c = 0; c < CD_.length; c++) {
                  if ($D_[o]["id"] == CD_[c]["id"]) {
                    $D_[o]["num"] = CD_[c]["num"] < 100 ? CD_[c]["num"] : "···";
                  }
                }
              }
            }
          }
        }
        return data;
      } else {
        return [];
      }
    },

    /**
     * 刷新用户信息和菜单信息
     */
    refreshUserInfoAndMenu() {
      // 清除用户缓存（包括用户信息和菜单缓存）
      this.$wxuserUtil.clearCache();

      // 使用新的刷新接口重新获取用户详细信息
      this.$wxuserUtil.refreshUserDetail(() => {
        // 用户信息获取成功后，重新获取菜单和工作台数量
        this.subMenuList_();

        // 显示切换成功提示
        this.$notify({
          message: '角色切换成功',
          duration: 1500,
          background: "#28a745",
        });
      });
    },
  },
  beforeMount() {},
  mounted() {
    this.subMenuList_();
    if (this.$wxuserUtil.isRoleSwitch()) {
      this.getSelectOptions();
      // 从 sessionStorage 读取之前存储的值
      const storedScope = this.$wxuserUtil.getScope();
      if (storedScope) {
        this.selectedValue = storedScope;
        this.tempSelectedValue = storedScope;
      }
    }
  },
  created() {
    var path = window.sessionStorage.getItem("redirect_path");
    var redirect_query = window.sessionStorage.getItem("redirect_query");
    if (path != "/") {
      if (redirect_query != "" && redirect_query != null) {
        path = path + "?" + redirect_query;
      }
      window.sessionStorage.removeItem("redirect_path");
      window.sessionStorage.removeItem("redirect_query");
      this.$router.push({ path: path });
    }

  },
  watch: {},
};
</script>



<style lang="less" src="~p/pageView-index.less"></style>
<style scoped>
.header-wrapper {
  display: flex;
  align-items: center;
}
.role-switch-container {
  margin-left: 15px;
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
  padding-bottom: 3px;
  flex: 1;
}
.role-select {
  width: 80%;
  height: 40px;
  border-radius: 5px;
  border: 1px solid #ddd;
  padding: 0 10px;
  height: 30px;
  font-size: 14px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue